import script from "./WareInReceiveMultiPallet.vue?vue&type=script&setup=true&lang=js"
export * from "./WareInReceiveMultiPallet.vue?vue&type=script&setup=true&lang=js"

import "./WareInReceiveMultiPallet.vue?vue&type=style&index=0&id=2285039a&scoped=true&lang=css"

import exportComponent from "/Users/zwl/Desktop/work/DEV/wms-phone/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2285039a"]])

export default __exports__